import type { MaybeRef, Ref } from 'vue';

import type { ImageMetadata } from '../types/image';
import type { LPSAxisDir } from '../types/lps';

import { computed, unref } from 'vue';

import { getLPSDirections } from '../utils/lps';

/**
 *
 * @param {Ref<LPSAxisDir>} viewDirection an LPS view look-direction
 * @param {Ref<LPSAxisDir>} viewUp an LPS view up-direction
 * @param {Ref<ImageMetadata>} imageMetadataRef image metadata
 */
export function useCameraOrientation(
  viewDirection: MaybeRef<LPSAxisDir>,
  viewUp: MaybeRef<LPSAxisDir>,
  imageMetadataRef: Ref<ImageMetadata>,
) {
  const orientationMatrix = computed(() => imageMetadataRef.value.orientation);
  const lpsDirections = computed(() =>
    getLPSDirections(orientationMatrix.value),
  );
  const cameraDirVec = computed(
    () => {
      return lpsDirections.value[unref(viewDirection)];
    },
  );
  const cameraUpVec = computed(() => {
    return lpsDirections.value[unref(viewUp)];
  });

  return {
    cameraDirVec,
    cameraUpVec,
  };
}
